// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1OjMO","header":"ReportDetails_header__26PJc","title":"ReportDetails_title__3hO_1","left":"ReportDetails_left__snZ32"};